import React from 'react'
import Hadear from './layout/Hadear'
import Footer from './layout/Footer'
import { Outlet } from 'react-router-dom';
import WhatsappIcon from '../pages/WhatsappIcon';
import PopUp from '../pages/PopUp';

const MainLayOut = () => {
  return (
    <>
      <Hadear />
      <Outlet />
      <WhatsappIcon />
      <Footer />
      <PopUp />

    </>
  );
}

export default MainLayOut